import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Button } from "react-bootstrap";
import { DoLogout } from "../Utils";

export default function AportesList(props) {
  const ls = require("localstorage-ttl");
  const [payInstructions, setPayInstructions] = useState(null);

  useEffect(() => {
    const token = JSON.parse(ls.get("jwt"));

    const headerRequest = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const mainGet = () => {
      const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

      axios
        .get(`${API_URL}/config`, headerRequest)
        .then((res) => res.data.data.attributes)
        .then((config) => {
          setPayInstructions(config.contributionInstructions);
        })
        .catch((error) => {
          console.log("Error with config:", error);
          if (error.response.status === 401) DoLogout();
        });
    };

    mainGet();
  }, []);

  return (
    <Container className="p-3 mb-4 bg-light rounded-3" fluid="lg">
      <h4>Aportes a la FAA Rendición de cuentas</h4>
      <div
        dangerouslySetInnerHTML={{
          __html: payInstructions,
        }}
      ></div>
      <Button
        size="sm"
        href="https://docs.google.com/spreadsheets/d/1r823-wqJ-C3VoNdPLu7MEeUPvmTHBvgGOWp2-d4wAC4/edit?usp=sharing"
        target="_blank"
        variant="success"
      >
        VER PLANILLA
      </Button>
    </Container>
  );
}
